import axios from 'axios'

export default async function pinArticleAtSection({ id }: { id: number }) {
  await axios.post('/api/v1/fixed/pin-at-section/add/', { id })
}
